import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createPinia } from 'pinia';

// Pinia Services
import { useAuthStore } from '@/stores/auth';

/** Pinia Service */
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export default pinia;
export { useAuthStore };
